import { render, staticRenderFns } from "./SigninPage.vue?vue&type=template&id=43f95f64"
import script from "./SigninPage.vue?vue&type=script&lang=js"
export * from "./SigninPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43f95f64')) {
      api.createRecord('43f95f64', component.options)
    } else {
      api.reload('43f95f64', component.options)
    }
    module.hot.accept("./SigninPage.vue?vue&type=template&id=43f95f64", function () {
      api.rerender('43f95f64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/auth/SigninPage.vue"
export default component.exports